import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Text,
  Button,
} from "@chakra-ui/react";
import { useEffect, useRef } from "react";

const ModalReadText = ({ prompt, content, isOpen, onClose }) => {
  const promptRef = useRef();

  useEffect(() => {
    setTimeout(() => {
      if (promptRef.current) {
        promptRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl">
      <ModalOverlay />
      {isOpen && (
        <>
          <ModalContent>
            <ModalHeader fontSize="xl" bg="black" color="white" ref={promptRef}>
              {prompt}
            </ModalHeader>
            <ModalBody fontSize="lg">
              {content.split("\n").map((line, i) => (
                <Text key={i} mt={4}>
                  {line}
                </Text>
              ))}
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="gray" mr={3} onClick={onClose}>
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </>
      )}
    </Modal>
  );
};

export default ModalReadText;
